import { differenceInDays, differenceInHours, differenceInMinutes, format, isValid } from "date-fns";

export function formatRelativeTime(date: Date): string {
  // Guard against an invalid Date (e.g. a corrupted/hand-edited localStorage
  // timestamp): the date-fns format() fallback below throws RangeError on an
  // Invalid Date, which would crash the calling widget. Degrade to "" instead.
  if (!isValid(date)) return "";
  const now = new Date();
  const minutes = differenceInMinutes(now, date);
  const hours = differenceInHours(now, date);
  const days = differenceInDays(now, date);

  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  return format(date, "MMM d");
}
